<h1 mat-dialog-title><strong>Création de groupe</strong></h1>
<form #f="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <div class="input-group">
      <mat-form-field>
        <mat-label>Nom</mat-label>
        <input
          matInput
          type="text"
          name="name"
          [(ngModel)]="group.name"
          #name="ngModel"
          [ngClass]="{ 'is-invalid': name.invalid && (name.dirty || name.touched) }"
          required />
        <div class="invalid-feedback">
          @if (name.errors?.['required']) {
          <span>Veuillez saisir le nom du groupe.</span>
          }
        </div>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea matInput type="text" name="description" [(ngModel)]="group.description"> </textarea>
      </mat-form-field>
      <div class="d-flex flex-row">
        @if (send) {
        <div class="spinner-border text-primary ms-3 mt-4" style="width: 2rem; height: 2rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        }
      </div>
    </div>
  </div>
  <mat-dialog-actions class="justify-content-end">
    <button mat-raised-button mat-dialog-close>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="f.invalid">Créer</button>
  </mat-dialog-actions>
</form>
